module.exports = __webpack_public_path__ + "img/napa_green_block.9638b927.jpg";